<template>
    <b-modal scrollable b-modal title="Paziente" ref="mdlExternalPrenotazioniPaziente" id="mdlExternalPrenotazioniPaziente" size="xl" @ok="onSalvaRichiesta" :ok-disabled="disabledOk && obbligoIdentificativoAnagrafica" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div v-if="step === 0">
            <paziente-edit-component :paziente="paziente" @update="onUpdatePaziente"></paziente-edit-component>
        </div>
        <div v-if="step === 1">
            <!-- Assegnazione Box -->
        </div>
        <modal-error ref="cmpModalError"> </modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import PazienteEditComponent from "../../pazienti/components/PazienteEditComponent.vue";
export default {
    props: {},
    mixins: [UtilityMixin],
    components: { ModalError, PazienteEditComponent }, //DatePicker
    data() {
        return {
            listKey: 0,
            pathResource: "/pazienti",
            pathResourceAgendaAppuntamento: "/agendaappuntamenti",
            nominativo: "",
            paziente: {},
            prenotazione: {},
            appuntamento: {},
            obbligoIdentificativoAnagrafica: false,
            step: 0,
            // idPrenotazione: null,
            id: null,
            disabledOk: true,
            jsonData: { meseAnnoRiferimento: null, idStruttura: null, idSetting: null },
            presidiOptions: [{ id: null, denominazione: "-Seleziona Valore-" }],
            settingOptions: [{ id: null, setting: "-Seleziona Valore-" }],
        };
    },
    mounted() {},

    watch: {},
    methods: {
        init(paziente, prenotazione) {
            let me = this;
            me.obbligoIdentificativoAnagrafica = this.appConfig.obbligoIdentificativoAnagrafica;
            me.paziente = paziente;
            me.prenotazione = prenotazione;
            me.disabledOk = !paziente.identificativo;
            // me.idPrenotazione = me.prenotazione.id;
            // console.log(me.prenotazione);

            me.$refs.mdlExternalPrenotazioniPaziente.show();
        },
        onUpdatePaziente(data) {
            let me = this;
            console.log(data.identificativo !== null && data.identificativo !== "");
            me.disabledOk = data.identificativo !== null && data.identificativo !== "" ? false : true;
            me.paziente = data;
        },
        onSalvaRichiesta(bvModalEvent) {
            let me = this;
            let payloadDaInviare = JSON.parse(JSON.stringify(this.paziente));
            if (payloadDaInviare.dataNascita && payloadDaInviare.personaRiferimento) {
                let dataNascita = new Date(payloadDaInviare.dataNascita);
                let oggi = new Date();
                let eta = oggi.getFullYear() - dataNascita.getFullYear();
                let meseDiff = oggi.getMonth() - dataNascita.getMonth();
                if (meseDiff < 0 || (meseDiff === 0 && oggi.getDate() < dataNascita.getDate())) {
                    eta--;
                }
                if (eta >= 18) {
                    payloadDaInviare.personaRiferimento = null;
                }
            }
            UtilityMixin.methods.saveResource(me.pathResource, payloadDaInviare, me.resultResponse, me.resultError);
            bvModalEvent.preventDefault();
        },
        resultResponse(response) {
            let me = this;
            me.paziente = response.data.data;
            me.aggiornaPrenotazione();
        },
        resultError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio, true);
        },
        aggiornaPrenotazione() {
            let me = this;
            me.loadAppuntamentoloadAppuntamento();
            //Prenndo l'appuntamento Aggiorno i dati da aggiornare salvo se va tutto a buon fine vado avanti
        },
        loadAppuntamentoloadAppuntamento() {
            let me = this;
            // console.log(me.prenotazione);

            let link = me.pathResourceAgendaAppuntamento + "/" + me.prenotazione.idAppuntamento;
            UtilityMixin.methods.loadDataResources(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            let obj = response.data.data;
            obj.identificativoAppuntamento = me.paziente.identificativo;
            obj.nome = me.paziente.nome;
            obj.dataNascita = me.paziente.dataNascita;
            UtilityMixin.methods.saveResource(me.pathResourceAgendaAppuntamento, obj, me.resultUpdateResponse, me.resultUpdateError);
        },
        resultUpdateResponse(response) {
            let me = this;
            response;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("idPrenotazione", me.prenotazione.idAppuntamento);
            me.$router.push("/paziente/consensi?idPaziente=" + me.paziente.id);
        },
        resultUpdateError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
